import { BROADCAST_SET_PRESENTER_ID } from 'actions/Types';

/**
 * @description Sets unique presenter identifier to be used for logging.
 * @param {string} presenterId
 * remove with studio.requirePresenterAuth
 */
function setPresenterId(presenterId) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_PRESENTER_ID,
      payload: presenterId
    };

    dispatch(action);
  };
}

export default setPresenterId;
